import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform<T>(array: T[], field: keyof T, reverse = false): T[] {
    if (!Array.isArray(array) || !field) return array;

    const sorted = [...array].sort((a, b) => {
      const aValue = a[field];
      const bValue = b[field];
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    });

    return reverse ? sorted.reverse() : sorted;
  }
}